/**
 * Created by Ning Jiang on 12/3/2019.
 */

require("@nolimitcity/slot-game/lib/gsap/src/umd/CustomWiggle.js");
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {TweenLite} from "gsap";
import {DeadwoodGameConfig} from "../../DeadwoodGameConfig";

export class ScatterReelNearWinView extends BaseView {

    private _layer:ScalableLayer;
    private _attentionContainer:PIXI.Container;
    private _glowSprite:PIXI.Sprite;
    private _burningSprite:PIXI.Sprite;
    private _burningSpine:PIXI.spine.Spine;
    private _explosionSprite:PIXI.Sprite;
    private _explosionSpine:PIXI.spine.Spine;

    private _currentReelId:number;
    private _isPlaying:boolean;
    private _stageTween:TweenLite | null;
    private _currentOrientation:Orientation;

    constructor() {
        super();

        CustomWiggle.create("stageWiggle", {wiggles : 90, type : "easeOut"});
        this.reset();
    }

    private createSpine(name:string):PIXI.spine.Spine {
        const spine:PIXI.spine.Spine = new PIXI.spine.Spine(GameResources.getSpineAsset(name));
        spine.autoUpdate = true;

        return spine;
    }

    private createSpineSprite(spine:PIXI.spine.Spine):PIXI.Sprite {
        const sprite:PIXI.Sprite = new PIXI.Sprite();
        sprite.anchor.set(0.5);
        sprite.addChild(spine);

        return sprite;
    }

    protected initAnimations():void {
        this._layer = StageManager.getLayer(DeadwoodGameConfig.instance.LAYERS.NEAR_WIN.name);

        this._glowSprite = new PIXI.Sprite(GameResources.getTextures("nearWinFireBg")[0]);
        this._glowSprite.blendMode = PIXI.BLEND_MODES.ADD;
        this._glowSprite.anchor.set(0.5);
        this._glowSprite.scale.y = 29.7;
        this._glowSprite.alpha = 0;
        this._burningSpine = this.createSpine("nearWin_burningTrack");
        this._burningSprite = this.createSpineSprite(this._burningSpine);
        this._explosionSpine = this.createSpine("nearWin_explosion");
        this._explosionSprite = this.createSpineSprite(this._explosionSpine);

        this._attentionContainer = new PIXI.Container();
        this._attentionContainer.addChild(this._glowSprite);
        this._attentionContainer.addChild(this._explosionSprite);
        this._attentionContainer.addChild(this._burningSprite);
        this._attentionContainer.alpha = 0;
        this._layer.addChild(this._attentionContainer);

        const mask:PIXI.Graphics = new PIXI.Graphics();
        mask.beginFill(0xff0000);
        mask.drawRect(GameConfig.instance.REEL_AREA_POS_X, DeadwoodGameConfig.instance.REEL_AREA_TOP, GameConfig.instance.REEL_AREA_WIDTH, DeadwoodGameConfig.instance.REEL_AREA_ACTUAL_HEIGHT);
        mask.endFill();
        this._layer.addChild(mask);
        this._attentionContainer.mask = mask;
    }

    private playSpine(spine:PIXI.spine.Spine, animationName:string):void {
        spine.state.clearTrack(0);
        spine.skeleton.setToSetupPose();
        spine.state.setAnimation(0, animationName, false);
    }

    public playFSNearWin(reelId:number):void {
        this._currentReelId = reelId;
        this._isPlaying = true;
        const positionX:number = GameConfig.instance.REEL_DISPLAY_POSITIONS[reelId][0] + GameConfig.instance.REEL_AREA_POS_X;
        const positionY:number = GameConfig.instance.REEL_DISPLAY_POSITIONS[2][1] + GameConfig.instance.SYMBOL_HEIGHT * 2;
        this._attentionContainer.position.set(positionX, positionY);
        this.playSpine(this._burningSpine, "nearWin_burningTrack");
        this.playSpine(this._explosionSpine, "animation");
        TweenLite.to(this._attentionContainer, 0.2, {alpha : 1});
        TweenLite.to(this._glowSprite, 2, {alpha : 1});
        // TODO: maybe shake differently if winning shoot out or fs or super fs.
        this.playStageShake();
    }

    private playStageShake():void {
        this._stageTween = TweenLite.to(StageManager.stage, 5, {y : "+=" + 4, ease : "stageWiggle"});
    }

    public stopNearWin(reelId:number):void {
        if(reelId != this._currentReelId) {
            debugger;
            throw new Error(`ScatterReelNearWinView.stopNearWin(): try to stop reel ${reelId} when current id is ${this._currentReelId}`);
        }

        this._isPlaying = false;
        TweenLite.to(this._attentionContainer, 0.3, {alpha : 0, onComplete : () => this.stopAllAnimations()});
        TweenLite.to(this._glowSprite, 0.2, {alpha : 0});
        if(this._stageTween && this._stageTween.isActive()) {
            this._stageTween.progress(1);
        }
    }

    private stopAllAnimations():void {
        this._burningSpine.state.setEmptyAnimation(0, 0);
        this._explosionSpine.state.setEmptyAnimation(0, 0);
    }

    public reset():void {
        this._currentReelId = -1;
    }

    protected onResize(resizeData:IResizeData):void {
        if(this._currentOrientation === resizeData.orientation) {
            return;
        }

        this._currentOrientation = resizeData.orientation;
        if(this._isPlaying && this._stageTween && this._stageTween.isActive()) {
            this._stageTween.progress(1);
            if(StageManager.legacyScaling) {
                StageManager.stage.position.set(NolimitApplication.screenBounds.left, NolimitApplication.screenBounds.top);
            }
            this.playStageShake();
        }
    }
}